module.exports = "../../../../platform/assets/pageMainIcon/yewuchulilei5.svg";